import React from 'react';
import { AppConst } from "../../constants";

const Footer = () => {
    return (
        <footer className="ps-footer">
            <div className="ps-footer-apps">
                <p className="ps-footer-apps-title">Install the Payswitch App</p>
                <div className="ps-store-btns">
                    <a href="https://play.google.com/store/apps/details?id=com.quidvis.payswitch.payswitch"
                       target="_blank" rel="noreferrer" className="ps-store-btn">
                        <svg viewBox="0 0 24 24" fill="currentColor">
                            <path d="M3 5.277c0-.987 1.09-1.576 1.918-1.03l13.623 8.98c.732.483.732 1.55 0 2.033L4.918 24.24C4.09 24.787 3 24.198 3 23.21V5.278z" />
                        </svg>
                        <div className="ps-store-btn-label">
                            <small>GET IT ON</small>
                            <strong>Google Play</strong>
                        </div>
                    </a>
                    <a href="https://apps.apple.com/ng/app/payswitch/id6476865861"
                       target="_blank" rel="noreferrer" className="ps-store-btn">
                        <svg viewBox="0 0 24 24" fill="currentColor">
                            <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M15.97 4.17c.66-.81 1.11-1.93.99-3.06-.96.04-2.13.64-2.82 1.45-.6.69-1.12 1.83-.98 2.94 1.07.08 2.15-.52 2.81-1.33" />
                        </svg>
                        <div className="ps-store-btn-label">
                            <small>DOWNLOAD ON THE</small>
                            <strong>App Store</strong>
                        </div>
                    </a>
                </div>
            </div>

            <div className="ps-footer-legal">
                <p>{AppConst.APP_NAME} © {AppConst.APP_YEAR}. All rights reserved.</p>
                <div className="ps-footer-links">
                    <a href="https://www.payswitch.africa/privacy" className="ps-footer-link" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
                    <span style={{ color: 'var(--slate-200)' }}>|</span>
                    <a href="https://www.payswitch.africa/terms" className="ps-footer-link" target="_blank" rel="noopener noreferrer">Terms and Conditions</a>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
